/**
 * NX-5882 — derive a payroll report table's `scroll.x` from its columns.
 *
 * These tables are `table-layout: fixed` (they carry `fixed: 'left'` columns),
 * so a column that declares no `width` only gets whatever is left of `scroll.x`
 * after the declared widths are taken. A hardcoded `scroll.x` silently rots as
 * columns are added: the remainder shrinks until those columns collapse to 0px,
 * wrap one character per line and overflow on top of the next cell.
 *
 * Deriving the width from the columns actually rendered keeps that from
 * happening again, whatever gets added later.
 */
import { ColumnsType } from 'antd/es/table';

/** Fallback width for columns that do not declare one. */
export const MIN_COLUMN_WIDTH = 160;

/** antd's row-selection checkbox column, which is not part of `columns`. */
export const SELECTION_COLUMN_WIDTH = 60;

export const getTableScrollX = <T,>(
  columns: ColumnsType<T>,
  { hasSelection = true }: { hasSelection?: boolean } = {},
): number =>
  columns.reduce(
    (total, column) =>
      total + (Number((column as { width?: number | string }).width) || MIN_COLUMN_WIDTH),
    hasSelection ? SELECTION_COLUMN_WIDTH : 0,
  );
